{
  "ariaLabelBackButton": "Gå tilbake",
  "ariaLabelCloseBtn": "Lukk"
}
